"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosError = exports.cleanAxiosError = void 0;
const cleanAxiosError = (error, options) => {
    if ((0, exports.isAxiosError)(error)) {
        return {
            errorMessage: error.message,
            errorCode: error.code || "N/A",
            requestUrl: (error.config?.baseURL ?? "") + error.config?.url,
            requestMethod: error.config?.method,
            ...(options?.includeRequestData
                ? { requestData: error.config?.data }
                : {}),
            responseData: error.response?.data,
            responseStatus: error.response?.status,
            responseHeaders: error.response?.headers,
        };
    }
    else {
        return error;
    }
};
exports.cleanAxiosError = cleanAxiosError;
const isAxiosError = (error) => {
    return (Boolean(error) &&
        typeof error === "object" &&
        Boolean(error?.isAxiosError));
};
exports.isAxiosError = isAxiosError;
//# sourceMappingURL=Axios.utils.js.map